import { render } from "./betsBar.vue?vue&type=template&id=e0357184"
import script from "./betsBar.vue?vue&type=script&lang=js"
export * from "./betsBar.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__